import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ReactQueryProvider from "./providers/ReactQueryProviders";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ReactQueryProvider>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </ReactQueryProvider>
); 